class EventUtils {
  constructor() {
    this.functionMap = {};
  }

  addEventListener(element, event, func) {
    this.functionMap[event] = func;
    element.addEventListener(event.split('.')[0], this.functionMap[event]);
  }

  removeEventListener(element, event) {
    element.removeEventListener(event.split('.')[0], this.functionMap[event]);
    delete this.functionMap[event];
  }
}

export let EventHelper = new EventUtils();



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/utils/EventUtils.js